<!-- Modal overlay when feedback dialog is open -->
<div class="feedback-overlay" *ngIf="isFeedbackDialogOpen"></div>

<!-- Chat Messages Container -->
<div class="chat-messages-container" #messagesContainer>
    
    <!-- Regular Messages -->
        <div class="chat-message" 
            *ngFor="let message of chatMessages; let i = index"
         [class.user-message]="message.sender === 'user'"
         [class.bot-message]="message.sender === 'bot'"
         [attr.data-message-role]="message.sender === 'bot' ? 'bot' : null">
        
        <!-- User or Bot Message Bubble -->
        <div class="message-bubble">
            <!-- All messages use markdown pipe for consistent rendering -->
            <div class="message-text"
                                    *ngIf="message.type !== 'document-results' && message.type !== 'drt-parameters' && message.type !== 'drt-result-table'"
                                    [innerHTML]="message.text | markdown"></div>

            <div class="drt-parameters-card" *ngIf="message.type === 'drt-parameters'">
                <div class="drt-parameters-title">DRT Parameters Extracted</div>

                <div *ngFor="let section of getDrtSections(message)">
                    <!-- Scope review card (highlighted) -->
                    <div class="drt-scope-review-card" *ngIf="section.isScopeReview">
                        <div class="drt-scope-review-title">
                            <span class="material-icons-outlined drt-scope-review-icon">fact_check</span>
                            {{ section.title }}
                        </div>
                        <div class="drt-scope-review-note">Please verify P numbers, service, coating/insulation and other crucial parameters before generation for maximum accuracy.</div>
                        <div class="drt-field-row drt-field-header">
                            <div class="drt-col-key">Field</div>
                            <div class="drt-col-value">Value</div>
                        </div>
                        <div class="drt-field-row" *ngFor="let field of section.fields; trackBy: trackByDrtField">
                            <div class="drt-col-key">{{ field.key }}</div>
                            <div class="drt-col-value">
                                <div class="drt-input-wrapper" [class.has-options]="$any(this).hasDrtDropdownOptions(message, field)">
                                    <input class="drt-value-input" type="text" [(ngModel)]="field.value"
                                        [disabled]="message.drtGeneratePending" placeholder="Enter value"
                                        autocomplete="off" [attr.aria-label]="section.title + ' - ' + field.key"
                                        (focus)="$any(this).onDrtFieldFocus(message, section, field)"
                                        (input)="$any(this).onDrtFieldInput(message, section, field)"
                                        (blur)="$any(this).onDrtFieldBlur(message, section, field)" />
                                    <button *ngIf="$any(this).hasDrtDropdownOptions(message, field)" type="button"
                                        class="drt-dropdown-toggle" [disabled]="message.drtGeneratePending"
                                        (mousedown)="$any(this).toggleDrtFieldSuggestions(message, section, field, $event)">
                                        <span class="material-icons-outlined">keyboard_arrow_down</span>
                                    </button>
                                </div>
                                <div class="drt-field-error" *ngIf="field.error" role="alert">{{ field.error }}</div>
                                <div class="drt-suggestions" *ngIf="$any(this).shouldShowDrtSuggestions(message, section, field) || $any(this).shouldShowDrtNoMatchState(message, section, field)">
                                    <button type="button" class="drt-suggestion-item"
                                        *ngFor="let option of $any(this).getFilteredDrtOptions(message, section, field)"
                                        (mousedown)="$any(this).selectDrtOption(message, section, field, option, $event)">{{ option }}</button>
                                    <div class="drt-suggestion-empty" *ngIf="$any(this).shouldShowDrtNoMatchState(message, section, field)">No matching options</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Regular section (process_info or scope_parameters) -->
                    <div class="drt-section" *ngIf="!section.isScopeReview">
                        <div class="drt-section-title">{{ section.title }}</div>

                        <div class="drt-groups" [class.drt-groups-tiles]="section.expanded && section.id === 'scope_parameters'">
                        <div class="drt-group-tile" *ngFor="let grp of $any(this).getVisibleDrtGroups(section); trackBy: trackByDrtGroup">
                        <div class="drt-group-heading" *ngIf="grp.name">{{ grp.name }}</div>
                        <ng-container *ngFor="let field of grp.fields; trackBy: trackByDrtField">
                        <div class="drt-field-row">
                            <div class="drt-col-key">{{ field.label || field.key }}</div>
                            <div class="drt-col-value">
                                <div class="drt-input-wrapper" [class.has-options]="$any(this).hasDrtDropdownOptions(message, field)">
                                    <input
                                        class="drt-value-input"
                                        type="text"
                                        [(ngModel)]="field.value"
                                        [disabled]="message.drtGeneratePending"
                                        placeholder="Enter value"
                                        title="DRT value input"
                                        autocomplete="off"
                                        [attr.aria-label]="section.title + ' - ' + (field.label || field.key)"
                                        (focus)="$any(this).onDrtFieldFocus(message, section, field)"
                                        (input)="$any(this).onDrtFieldInput(message, section, field)"
                                        (blur)="$any(this).onDrtFieldBlur(message, section, field)" />

                                    <button
                                        *ngIf="$any(this).hasDrtDropdownOptions(message, field)"
                                        type="button"
                                        class="drt-dropdown-toggle"
                                        [disabled]="message.drtGeneratePending"
                                        [attr.aria-label]="'Show options for ' + (field.label || field.key)"
                                        (mousedown)="$any(this).toggleDrtFieldSuggestions(message, section, field, $event)">
                                        <span class="material-icons-outlined">keyboard_arrow_down</span>
                                    </button>
                                </div>
                                <div class="drt-field-error" *ngIf="field.error" role="alert">{{ field.error }}</div>

                                <div class="drt-suggestions" *ngIf="$any(this).shouldShowDrtSuggestions(message, section, field) || $any(this).shouldShowDrtNoMatchState(message, section, field)">
                                    <button
                                        type="button"
                                        class="drt-suggestion-item"
                                        *ngFor="let option of $any(this).getFilteredDrtOptions(message, section, field)"
                                        (mousedown)="$any(this).selectDrtOption(message, section, field, option, $event)">
                                        {{ option }}
                                    </button>
                                    <div class="drt-suggestion-empty" *ngIf="$any(this).shouldShowDrtNoMatchState(message, section, field)">
                                        No matching options
                                    </div>
                                </div>
                            </div>
                        </div>
                        </ng-container>
                        </div>
                        </div>

                        <button
                            type="button"
                            class="drt-see-more-btn"
                            *ngIf="$any(this).getHiddenDrtFieldCount(section) > 0"
                            (click)="$any(this).toggleDrtSectionExpanded(section)">
                            {{ section.expanded ? 'See less' : 'See more (' + $any(this).getHiddenDrtFieldCount(section) + ')' }}
                        </button>
                    </div>
                </div>

                <div class="drt-actions">
                    <button
                        *ngIf="!message.drtGeneratePending"
                        type="button"
                        class="drt-generate-btn"
                        (click)="onDrtGenerate(message)">
                        Confirm and proceed
                    </button>
                </div>
            </div>

            <div class="document-results"
                 *ngIf="message.type === 'document-results' || (message.sender === 'bot' && message.type === 'text' && message.documents && message.documents.length > 0)">
                <!-- Filter fallback notice — shown when user filters returned no results -->
                <div class="filter-fallback-notice"
                     *ngIf="message.type === 'document-results' && message.filterFallbackNotice"
                     [innerHTML]="message.filterFallbackNotice | markdown"></div>
                <!-- Title: for pure EWO responses show the count; for combined synthesis show a section heading -->
                <div class="document-results-title" *ngIf="message.type === 'document-results'" [innerHTML]="message.text | markdown"></div>
                <div class="document-results-title" *ngIf="message.type !== 'document-results'">EWO Documents Referenced</div>

                <!-- EWO Smart Filter Bar — only shows when EWO cards are present -->
                <app-ewo-filter-bar
                    *ngIf="hasEwoCards(message)"
                    [documents]="message.documents || []"
                    (filteredIds)="onEwoFilterChange(i, $event, message.id)">
                </app-ewo-filter-bar>

                <div class="document-cards-grid">
                    <div class="document-card"
                        *ngFor="let doc of getDisplayDocs(i, message)">
                        <div class="document-card-header">
                            <div class="document-title">{{ doc.title }}</div>
                            <input
                                type="checkbox"
                                class="document-checkbox"
                                [checked]="doc.selected !== false"
                                (change)="onDocumentSelectionChange(doc, $event)"
                                aria-label="Document selected" />
                        </div>

                        <!-- EWO-specific card fields -->
                        <ng-container *ngIf="doc.documentType === 'EWO'; else genericCard">
                            <div class="ewo-card-fields">
                                <div class="ewo-field" *ngIf="doc.ewoId">
                                    <span class="ewo-label">EWO ID</span>
                                    <span class="ewo-value">{{ doc.ewoId }}</span>
                                </div>
                                <div class="ewo-field" *ngIf="doc.facility">
                                    <span class="ewo-label">Facility</span>
                                    <span class="ewo-value">{{ doc.facility }}</span>
                                </div>
                                <div class="ewo-field" *ngIf="doc.discipline">
                                    <span class="ewo-label">Discipline</span>
                                    <span class="ewo-value ewo-pill">{{ doc.discipline }}</span>
                                </div>
                                <div class="ewo-field" *ngIf="doc.date">
                                    <span class="ewo-label">Date</span>
                                    <span class="ewo-value">{{ doc.date }}</span>
                                </div>
                                <div class="ewo-approval" *ngIf="doc.approvalStatus">
                                    {{ doc.approvalStatus }}
                                </div>
                            </div>
                        </ng-container>

                        <!-- Generic (non-EWO) card fields -->
                        <ng-template #genericCard>
                            <div class="document-meta-row">
                                <span class="document-date">{{ doc.date }}</span>
                                <span class="document-type-pill">{{ doc.documentType }}</span>
                            </div>
                            <div class="document-summary">{{ doc.summary }}</div>
                        </ng-template>

                        <div class="document-card-actions">
                            <a *ngIf="doc.previewUrl"
                               class="document-open-btn"
                               [href]="doc.previewUrl"
                               target="_blank"
                               rel="noopener noreferrer">
                                <span class="material-icons">open_in_new</span>
                                Open Document
                            </a>
                            <button
                                type="button"
                                class="document-preview-btn"
                                (click)="onPreviewDocument(doc)">
                                Preview
                            </button>
                        </div>
                    </div>
                </div>

                <div class="ewo-show-more-row" *ngIf="canShowEwoShowMore(message)">
                    <button
                        type="button"
                        class="ewo-show-more-btn"
                        (click)="onShowMoreEwos(message)">
                        Show More
                    </button>
                </div>

                <app-drt-parameters-table
                    *ngIf="message.type !== 'drt-result-table' && message.documents && message.documents.length > 0"
                    [documents]="message.documents">
                </app-drt-parameters-table>
            </div>

            <div class="document-results" *ngIf="message.type === 'drt-result-table'">
                <div class="document-results-title">Generated DRT Summary</div>
                <app-drt-parameters-table
                    *ngIf="message.documents && message.documents.length > 0"
                    [documents]="message.documents"
                    [tableTitle]="'DRT TABLE'"
                    [initiallyExpanded]="true"
                    [dynamicColumns]="true">
                </app-drt-parameters-table>
            </div>
            
            <!-- Attached files (user messages) -->
            <div class="message-files" *ngIf="message.sender === 'user' && message.files && message.files.length > 0">
                <span class="files-icon">attach_file</span>
                <span class="files-text">{{ message.files.join(', ') }}</span>
            </div>
            
            <!-- Data sources (user messages) -->
            <div class="message-files" *ngIf="message.sender === 'user' && message.dataSources && message.dataSources.length > 0">
                <span class="files-icon">folder</span>
                <span class="files-text">{{ message.dataSources.join(', ') }}</span>
            </div>
        </div>

        <!-- Routing and metadata for bot messages -->
        <div class="message-metadata" *ngIf="message.sender === 'bot' && message.routing">
            <div class="routing-info">
                <span class="routing-label">Agent:</span>
                <span class="routing-value">{{ getAgentDisplay(message.agent) }}</span>
            </div>
            <div class="routing-info" *ngIf="message.routing.secondary_agents?.length">
                <span class="routing-label">Secondary Agents:</span>
                <span class="routing-value">{{ getSecondaryAgentsDisplay(message.routing.secondary_agents) }}</span>
            </div>
            <div class="routing-info">
                <span class="routing-label">Reasoning:</span>
                <span class="routing-value">
                    <ng-container *ngIf="message.routing.reasoning as reasoning">
                        {{ reasoning.includes(generalFallbackReasoning) ? reasoning.split(generalFallbackReasoning)[0] : reasoning }}<strong *ngIf="reasoning.includes(generalFallbackReasoning)">{{ generalFallbackReasoning }}</strong>
                    </ng-container>
                </span>
            </div>
        </div>

        <div class="citations-section" *ngIf="message.sender === 'bot' && message.type !== 'document-results' && (!message.documents || message.documents.length === 0) && message.citations && (message.citations | keyvalue).length > 0 && !((((message.text || '') + ' ' + (message.htmlContent || '')).toLowerCase()).includes('sources referenced')) && !((((message.text || '') + ' ' + (message.htmlContent || '')).toLowerCase()).includes('source referenced')) && !((((message.text || '') + ' ' + (message.htmlContent || '')).toLowerCase()).includes('## sources referenced')) && !((((message.text || '') + ' ' + (message.htmlContent || '')).toLowerCase()).includes('### sources referenced')) && !((((message.text || '') + ' ' + (message.htmlContent || '')).toLowerCase()).includes('sources:'))">
            <div class="citations-header">Sources Referenced:</div>
            <div class="citations-list">
                <a *ngFor="let citation of message.citations | keyvalue"
                   [href]="citation.value"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="citation-link">
                    {{ citation.key }}
                </a>
            </div>
        </div>

        <!-- Bot feedback actions -->
        <div class="message-actions" *ngIf="canShowFeedbackControls(message)">
            <button
                type="button"
                class="action-btn"
                [class.active]="message.feedbackSelection === 'like'"
                aria-label="Like response"
                (click)="onFeedbackAction(message, 'like')">
                <span class="material-icons-outlined">thumb_up</span>
            </button>
            <button
                type="button"
                class="action-btn"
                [class.active]="message.feedbackSelection === 'dislike'"
                aria-label="Dislike response"
                (click)="onFeedbackAction(message, 'dislike')">
                <span class="material-icons-outlined">thumb_down</span>
            </button>
        </div>

        <!-- Follow-up suggestion chips (below all bot message content) -->
        <div class="suggestion-chips"
            *ngIf="message.sender === 'bot' && message.suggestions && message.suggestions.length > 0">
            <button
                type="button"
                class="suggestion-chip"
                [class.suggestion-chip--disabled]="suggestionsDisabled"
                *ngFor="let suggestion of message.suggestions; let si = index"
                [style.animation-delay]="suggestionsDisabled ? '0ms' : (si * 150 + 'ms')"
                [disabled]="suggestionsDisabled"
                (click)="!suggestionsDisabled && suggestionClicked.emit(suggestion)">
                {{ suggestion }}
            </button>
        </div>

        <!-- Feedback dialog for bot messages -->
        <div class="feedback-dialog" *ngIf="canShowFeedbackControls(message) && message.feedbackDialogOpen && !message.feedbackSubmitted">
            <div class="feedback-header">
                <span class="feedback-title">Quick Feedback Survey</span>
            </div>

            <div class="feedback-section">
                <div class="feedback-question">How relevant was this response?</div>
                <div class="feedback-options">
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'relevance-' + (message.id || i)"
                            value="very"
                            [(ngModel)]="message.feedbackRelevance" />
                        Very Relevant
                    </label>
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'relevance-' + (message.id || i)"
                            value="partial"
                            [(ngModel)]="message.feedbackRelevance" />
                        Partially Relevant
                    </label>
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'relevance-' + (message.id || i)"
                            value="not"
                            [(ngModel)]="message.feedbackRelevance" />
                        Not Relevant
                    </label>
                </div>
            </div>

            <div class="feedback-section">
                <div class="feedback-question">Was the response complete?</div>
                <div class="feedback-options">
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'completeness-' + (message.id || i)"
                            value="complete"
                            [(ngModel)]="message.feedbackCompleteness" />
                        Yes, complete
                    </label>
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'completeness-' + (message.id || i)"
                            value="incomplete"
                            [(ngModel)]="message.feedbackCompleteness" />
                        No, incomplete
                    </label>
                    <label class="feedback-option">
                        <input
                            type="radio"
                            [name]="'completeness-' + (message.id || i)"
                            value="unsure"
                            [(ngModel)]="message.feedbackCompleteness" />
                        Not sure
                    </label>
                </div>
            </div>

            <div class="feedback-section">
                <div class="feedback-question">How would you rate the response?</div>
                <div class="feedback-stars">
                    <button
                        type="button"
                        class="star"
                        [class.filled]="(message.feedbackRating ?? 0) >= 1"
                        (click)="message.feedbackRating = 1"
                        aria-label="Rate 1 star">
                        <span class="material-icons-outlined">star</span>
                    </button>
                    <button
                        type="button"
                        class="star"
                        [class.filled]="(message.feedbackRating ?? 0) >= 2"
                        (click)="message.feedbackRating = 2"
                        aria-label="Rate 2 stars">
                        <span class="material-icons-outlined">star</span>
                    </button>
                    <button
                        type="button"
                        class="star"
                        [class.filled]="(message.feedbackRating ?? 0) >= 3"
                        (click)="message.feedbackRating = 3"
                        aria-label="Rate 3 stars">
                        <span class="material-icons-outlined">star</span>
                    </button>
                    <button
                        type="button"
                        class="star"
                        [class.filled]="(message.feedbackRating ?? 0) >= 4"
                        (click)="message.feedbackRating = 4"
                        aria-label="Rate 4 stars">
                        <span class="material-icons-outlined">star</span>
                    </button>
                    <button
                        type="button"
                        class="star"
                        [class.filled]="(message.feedbackRating ?? 0) >= 5"
                        (click)="message.feedbackRating = 5"
                        aria-label="Rate 5 stars">
                        <span class="material-icons-outlined">star</span>
                    </button>
                </div>
            </div>

            <div class="feedback-section">
                <div class="feedback-question">
                    Additional comments
                    <span *ngIf="message.feedbackSelection === 'dislike'"> (required)</span>
                    <span *ngIf="message.feedbackSelection !== 'dislike'"> (optional)</span>
                </div>
                <textarea
                    class="feedback-textarea"
                    rows="3"
                    [(ngModel)]="message.feedbackComments"
                    [required]="message.feedbackSelection === 'dislike'"
                    [placeholder]="message.feedbackSelection === 'dislike' ? 'Please tell us what went wrong' : 'Share details to improve future responses'"></textarea>
            </div>

            <div class="feedback-actions">
                <button
                    type="button"
                    class="feedback-submit"
                    [disabled]="isFeedbackSubmitDisabled(message)"
                    (click)="submitFeedback(message, i)">
                    Submit
                </button>
                <button type="button" class="feedback-cancel" (click)="closeFeedback(message)">
                    Cancel
                </button>
            </div>
        </div>
    </div>

    <!-- Loading Indicator -->
    <div class="chat-message bot-message" *ngIf="isLoading">
        <div class="message-bubble loading-bubble">
            <ul class="drt-progress" *ngIf="drtProgress.length" aria-live="polite">
                <li *ngFor="let s of drtProgress" [ngClass]="'drt-step-' + s.status">
                    <span class="material-icons drt-step-icon" *ngIf="s.status === 'done'">check_circle</span>
                    <span class="material-icons drt-step-icon" *ngIf="s.status === 'error'">error</span>
                    <span class="drt-step-spinner" *ngIf="s.status === 'start' || s.status === 'progress'"></span>
                    <span class="drt-step-label">{{ s.label }}</span>
                    <span class="drt-step-detail" *ngIf="s.detail">{{ s.detail }}</span>
                </li>
            </ul>
            <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
</div>

<div class="document-preview-overlay" *ngIf="previewDocument"></div>

<aside class="document-preview-drawer" *ngIf="previewDocument" role="dialog" aria-modal="true" [style.width.px]="previewDrawerWidth">
    <div class="preview-resize-handle" (mousedown)="startPreviewResize($event)" aria-hidden="true"></div>
    <div class="preview-drawer-header">
        <h3 class="preview-title">{{ previewDocument.title }}</h3>
        <button
            type="button"
            class="preview-close-btn"
            aria-label="Close preview"
            (click)="closePreviewDocument()">
            <span class="material-icons">close</span>
        </button>
    </div>

    <!-- EWO preview -->
    <ng-container *ngIf="previewDocument.documentType === 'EWO'; else genericPreview">
        <div class="preview-meta">
            <span class="ewo-pill-sm">EWO</span>
            <span *ngIf="previewDocument.approvalStatus" class="preview-approval">{{ previewDocument.approvalStatus }}</span>
        </div>

        <div class="ewo-preview-fields">
            <ng-container *ngFor="let field of getDefaultEwoPreviewFields(previewDocument)">
                <span class="ewo-preview-label">{{ field.label }}</span>
                <span class="ewo-preview-value">{{ field.value }}</span>
            </ng-container>
        </div>

        <div class="preview-section preview-toggle-section" *ngIf="hasExpandableEwoPreviewContent(previewDocument)">
            <button
                type="button"
                class="preview-toggle-btn"
                (click)="toggleEwoPreviewExpanded()">
                {{ isEwoPreviewExpanded ? 'View Less' : 'View More' }}
            </button>
        </div>

        <ng-container *ngIf="isEwoPreviewExpanded">
            <div class="ewo-preview-fields" *ngIf="getExpandedEwoPreviewFields(previewDocument).length > 0">
                <ng-container *ngFor="let field of getExpandedEwoPreviewFields(previewDocument)">
                    <span class="ewo-preview-label">{{ field.label }}</span>
                    <span class="ewo-preview-value">{{ field.value }}</span>
                </ng-container>
            </div>

            <div class="preview-section" *ngIf="$any(previewDocument).__cancelledWorkOrders?.length > 0">
                <div class="preview-label">Related Cancelled Work Orders</div>
                <ul class="related-workorder-list">
                    <li *ngFor="let item of $any(previewDocument).__cancelledWorkOrders">
                        <a [href]="item.url" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                        <span *ngIf="item.description" class="related-workorder-desc">- {{ item.description }}</span>
                    </li>
                </ul>
            </div>
        </ng-container>

        <div class="preview-section" *ngIf="$any(previewDocument).__revisionWorkOrders?.length > 0">
            <div class="preview-label">Related Revision Work Orders</div>
            <ul class="related-workorder-list">
                <li *ngFor="let item of $any(previewDocument).__revisionWorkOrders">
                    <a [href]="item.url" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                    <span *ngIf="item.description" class="related-workorder-desc">- {{ item.description }}</span>
                </li>
            </ul>
        </div>

        <div class="preview-section" *ngIf="previewDocument.previewUrl">
            <a class="ewo-pdf-link"
               [href]="previewDocument.previewUrl"
               target="_blank"
               rel="noopener noreferrer">
                <span class="material-icons">open_in_new</span>
                Open Full Document (PDF)
            </a>
        </div>
    </ng-container>

    <!-- Generic (non-EWO) preview -->
    <ng-template #genericPreview>
        <div class="preview-meta">{{ previewDocument.documentType }} - {{ previewDocument.date }}</div>

        <div class="preview-section" *ngIf="previewDocument.relevance !== undefined">
            <div class="preview-label">Relevance: {{ previewDocument.relevance }}%</div>
        </div>

        <div class="preview-section">
            <div class="preview-label">Summary:</div>
            <div class="preview-text">{{ previewDocument.summary }}</div>
        </div>

        <div class="preview-section">
            <div class="preview-label">Full Document Content (Mock)</div>
            <div class="preview-text">{{ previewDocument.fullContent || 'Preview content not available.' }}</div>
        </div>40, 50(25th)
    </ng-template>
</aside>
